const watermark: {
  image: HTMLImageElement | undefined;
  src: string;
} = {
  image: undefined,
  src: require("../../assets/images/watermark.png"),
};

const WatermarkPlugin = {
  beforeInit: (chart: Chart) => {
    const image = new Image();

    image.src = watermark.src;
    image.onload = () => {
      watermark.image = image;
      chart.update();
    };
  },

  afterDraw: (chart: Chart) => {
    if (chart.ctx && watermark.image) {
      const ctx = chart.ctx;

      ctx.save();
      ctx.drawImage(watermark.image, 65, 15, 83, 26);
      ctx.restore();
    }
  },
};

export default WatermarkPlugin;
